import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useConsent, readConsent } from '../lib/consent';
import { updateAnalyticsConsent, trackPage } from '../lib/analytics';
export default function GoogleAnalytics() {
  const consent = useConsent();
  const { pathname } = useLocation();
  useEffect(() => {
    const sync = () => updateAnalyticsConsent(Boolean(readConsent()?.analytics));
    sync();
    window.addEventListener('standard-consent-change', sync);
    window.addEventListener('storage', sync);
    return () => { window.removeEventListener('standard-consent-change', sync); window.removeEventListener('storage', sync); };
  }, []);
  useEffect(() => {
    updateAnalyticsConsent(Boolean(consent?.analytics));
    if (consent?.analytics) trackPage(pathname);
  }, [consent?.analytics, pathname]);
  return null;
}
